// extracted by mini-css-extract-plugin
module.exports = {"crossSellings":"CrossSellings_crossSellings__auMjc"};